var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.859,339.663c0-11.391-5.325-21.54-13.68-28.055c8.354-6.515,13.774-16.664,13.774-28.055    c0-11.993-6.207-22.611-15.328-29.058c9.183-7.254,14.858-18.476,14.858-31.06V148.74l-71.909-93.632h15.8V0H200.156v55.108    h16.801l-72.91,93.632v74.697c0,12.584,6.161,23.805,15.344,31.06c-9.121,6.447-14.968,17.064-14.968,29.058    c0,11.391,5.451,21.54,13.805,28.055c-8.354,6.515-13.711,16.664-13.711,28.055c0,11.993,5.737,22.611,14.858,29.058    c-9.183,7.254-15.328,18.476-15.328,31.06v64.125c0,21.823,18.256,40.078,40.078,40.078h40.078v-0.659    c6.671,5.12,15.007,8.675,24.047,8.675h16.031c9.04,0,17.376-3.554,24.047-8.675v0.659h40.078    c21.823,0,39.076-18.256,39.076-40.078v-64.125c0-12.584-5.66-23.805-14.843-31.06    C361.761,362.275,367.859,351.657,367.859,339.663z M215.186,40.078V15.029h81.159v25.049H215.186z M235.919,55.108h40.692    l68.596,89.174H167.323L235.919,55.108z M332.415,319.624c11.326,0,20.54,9.214,20.54,20.54s-9.214,20.54-20.54,20.54h-20.039    v15.029h16.031c13.536,0,24.047,10.511,24.047,24.047v64.125c0,13.536-10.51,25.049-24.047,25.049h-28.18    c2.325-6.012,3.632-11.134,3.632-17.033H288.83c0,13.536-11.012,25.049-24.548,25.049H248.25    c-13.535,0-24.548-11.512-24.548-25.049h-15.029c0,5.9,1.307,11.022,3.632,17.033h-28.18c-13.535,0-25.049-11.512-25.049-25.049    v-64.125c0-13.536,11.513-24.047,25.049-24.047h80.157v-15.029h-84.164c-11.326,0-20.54-9.214-20.54-20.54    s9.214-20.54,20.54-20.54h84.164v-15.029h-84.164c-11.326,0-20.54-9.214-20.54-20.54s9.214-20.54,20.54-20.54h84.164v-15.029    h-80.157c-13.535,0-25.049-11.512-25.049-25.049v-64.125h193.378v64.125c0,13.536-10.51,25.049-24.047,25.049h-16.031v15.029    h20.039c11.326,0,20.54,9.214,20.54,20.54s-9.214,20.54-20.54,20.54h-20.039v15.029H332.415z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 112.219,
    width: 16.031,
    height: 15.029,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.192,
    y: 96.188,
    width: 16.031,
    height: 15.029,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.317,
    y: 304.595,
    width: 16.031,
    height: 15.029,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.317,
    y: 248.485,
    width: 16.031,
    height: 15.029,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.317,
    y: 360.704,
    width: 16.031,
    height: 15.029,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.1b7ef84a6db42ad8cf9912d1f07af3e5.svg";
export { ForwardRef as ReactComponent };